import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';

export class ValidatePassportService extends HttpServiceBase {

  handle = (input: ValidatePassportServiceInput): Promise<ValidatePassportServiceOutput | null> => {
    const resourceSourceName = this.getSislogResourceSourceName();
    const promise = new Promise<ValidatePassportServiceOutput>((resolve, reject) => {
      const apikey = this.http.getApiKey(resourceSourceName);
      if (apikey) {
        return resolve({
          apikey
        });
      }
      this.http.post<ValidatePassportServiceOutput, ValidatePassportServiceInput>(
        `${this.baseUrlSislogApi}/point-of-sale/passport-validation`, input
      ).then(result => {
        if (result?.apikey) {
          this.http.setApiKey(resourceSourceName, result?.apikey);
          return resolve({
            apikey: result?.apikey
          });
        }
        return reject({
          message: ''
        });
      }).catch((error) => {
        console.log('error', error)
        return reject({
          message: ((error?.message||'') + ' ' + (error?.response?.statusText||'')).trim()
        });
      });
    });
    return promise;
  }
}

export class ValidatePassportServiceInput {
  shopifyOrderId: string;
  partnerUid: string;
  passport: string;
}

export class ValidatePassportServiceOutput {
  apikey: string;
}